module.exports = __webpack_public_path__ + "img/role-head-back.a1d39fe0.png";